import React, { useState } from "react";
import { Card, Form, Table } from "react-bootstrap";
import CustomRadioExample from "../FormBank/Components/CustomCheckExample";

const FormBankMobile = (props) => {
  const [selectedTax, setSelectedTax] = useState({});

  const groupName = props.id ? `taxOption-${props.id}` : "taxOption";

  const handleRadioChange = (radioId, category) => {
    setSelectedTax((prev) => {
      const currentSelected = prev[props.id];
      const newSelection = currentSelected === radioId ? "" : radioId;

      if (props.onSelect) {
        props.onSelect(newSelection, category);
      }

      return {
        ...prev,
        [props.id]: newSelection,
      };
    });
  };

  const renderTaxField = (taxName, taxValue, category, radioId) => {
    if (!taxName || !taxValue) return null;
    return (
      <td key={radioId}>
        <label
          htmlFor={radioId}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            cursor: "pointer",
            userSelect: "none",
          }}
        >
          <CustomRadioExample
            disabled={props.disabled}
            id={radioId}
            name={groupName}
            label={taxName}
            checked={selectedTax[props.id] === radioId}
            onClick={() => handleRadioChange(radioId, category)}
          />
          <TaxBadge value={taxValue} disable={props.disabled} />
        </label>
      </td>
    );
  };

  const TaxBadge = ({ value }) => <span className="tax-badge">{value}</span>;

  return (
    <div className="d-flex justify-content-center align-items-center mb-2">
      <Card bg= {props.disabled ? "light  " : undefined} style={{ width: "20rem", borderRadius: "8px" } }>
        <Card.Body  >
          <div className="text-center mb-3">
            <img
              src={props.src}
              alt="Img Icon"
              style={{ width: "auto", height: "auto" }}
            />
          </div>
          <Form>
            <div>
              {renderTaxField(
                props.firstNameTax,
                props.firstTax,
                "firstTax",
                props.firstId
              )}
            </div>
            <div>
              {renderTaxField(
                props.secondNameTax,
                props.secondTax,
                "secondTax",
                props.secondId
              )}
            </div>

            <div>
              {renderTaxField(
                props.thirdNameTax,
                props.thirdTax,
                "thirdTax",
                props.thirdId
              )}
            </div>
            <div>
              {renderTaxField(
                props.fourthNameTax,
                props.fourthTax,
                "fourthTax",
                props.fourthId
              )}
            </div>
            <div>
              {renderTaxField(
                props.fifthNameTax,
                props.fifthTax,
                "fifthTax",
                props.fifthId
              )}
            </div>
            <div>
              {renderTaxField(
                props.sixthNameTax,
                props.sixthTax,
                "sixthTax",
                props.sixthId
              )}
            </div>
          </Form>
        </Card.Body>
      </Card>
    </div>
  );
};

export default FormBankMobile;
